import Table from 'src/components/Table';
import React, { useMemo, useState } from 'react';
import { useIsFetching, useMutation } from 'react-query';
import queryKeys from 'src/constants/queryKeys';
import { chatgenieAPI } from 'src/config/api';
import { queryClient } from 'src/config/queryClient';
import { useHistory } from 'react-router-dom';
import SimpleButton from 'src/components/SimpleButton';
import InfoCard from 'src/components/InfoCard';
import ConfirmModal from 'src/components/ConfirmModal';
import useToast from 'src/hooks/useToast';
import { getColumns } from './config';
import { AgentHeader } from './style';

const Agent = () => {
  const [data, setData] = useState(
    queryClient.getQueryData([queryKeys.GET_AGENTS, { page: 1 }]) || []
  );
  const [confirmDeleteData, setConfirmDeleteData] = useState({
    id: null,
    isConfirming: false
  });
  const { toast } = useToast();
  const { mutate, isLoading } = useMutation(id => chatgenieAPI.deleteIntent(id), {
    onSuccess: () => {
      queryClient
        .refetchQueries([queryKeys.GET_AGENTS, { page: 1 }])
        .then(() => setData(queryClient.getQueryData([queryKeys.GET_AGENTS, { page: 1 }]) || []));
      setConfirmDeleteData({
        id: null,
        isConfirming: false
      });
    },
    onError(err) {
      toast.error(`Failed to delete intent: ${err?.response?.data?.message || err?.message}`);
    }
  });
  const isFetching = useIsFetching({ queryKey: [queryKeys.GET_AGENTS, { page: 1 }] });
  const [errorMessage, setErrorMessage] = useState('');
  const getData = params => {
    const page = params?.page || 1;
    setData(queryClient.getQueryData([queryKeys.GET_AGENTS]) || []);
    queryClient
      .fetchQuery({
        queryKey: [queryKeys.GET_AGENTS, { page }],
        queryFn: () => chatgenieAPI.getAgents({ page, query: '' })
      })
      .then(res => {
        setErrorMessage('');
        setData(res);
      })
      .catch(err => {
        setErrorMessage(err?.response?.data?.message || err?.message);
      });
  };

  const history = useHistory();
  const onEditClick = row => {
    history.push(`/dashboard/magic/agent/update/${row.id}`);
  };
  const onDeleteClick = row => {
    setConfirmDeleteData({
      id: row.id,
      isConfirming: true
    });
  };
  const columns = useMemo(() => getColumns({ onEditClick, onDeleteClick }), []);

  return (
    <>
      <AgentHeader>
        <div>
          <h5>Service Catalog</h5>
          <SimpleButton
            onClick={() => {
              history.push('/dashboard/magic/agent/create');
            }}
          >
            Create Intent
          </SimpleButton>
        </div>
        <InfoCard marginTop={10}>
          Magic Agent will use this service catalog to trigger the scenario. You can edit or disable
          any item, you can also define the scenario per client.
        </InfoCard>
      </AgentHeader>
      <Table
        isSearch={false}
        showTopPanelMeta={false}
        getData={getData}
        isLoading={!!isFetching}
        error={errorMessage}
        columns={columns}
        rows={{
          data,
          meta: {
            current_page: 1,
            from: data.length,
            last_page: 1,
            to: data.length,
            total: data.length
          }
        }}
      />
      <ConfirmModal
        isOpen={confirmDeleteData.isConfirming}
        toggleHandler={() => setConfirmDeleteData({ id: null, isConfirming: false })}
        title="Delete intent"
        description={<span>Are you sure you want to delete this intent?</span>}
        modalType="error"
        cancelText="Cancel"
        submitText="Yes"
        isLoading={isLoading}
        onSubmit={() => mutate(confirmDeleteData.id)}
      />
    </>
  );
};

export default Agent;
